import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import ObjectForm from '../../components/ObjectForm'

import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

import config from '../../config.json'

const PlatformStatusForm = ({open, close, model,  ...rest}) => {
  const app = React.useContext(AppContext)
  const { recall, setRecall } = app
  const { create, update  } = app.platformstatuses

  const scope = model?"Editar" : "Añadir"
  const submit = d=>  model?update(d):create(d)
  return (
    <Dialog onClose={close} open={open}>
      <DialogTitle>{scope} Estado de Plataforma</DialogTitle>
      <ObjectForm ignored={['id']} recall={recall} submit={submit}
        stc={{ vendor: app.vendor }}
        obj={{type:'', name:'', }}
        labels={{type:'Tipo', name:'Status', }}
        types={{type:'select', name:'text', }}
        options={{type: config.availablePlatformStatusTypes}}
        changed={model?{...model}:{}} 
      />
      <Button onClick={() => {setRecall(true);close()}}>{scope}</Button>
    </Dialog>
  )
}
export default PlatformStatusForm